import React, {useEffect, useRef, useState} from 'react';
import Button from '../../../../../../../components/form/button/button';
import {assets} from '../../../../../../../utils/assetsSrc';
import {useLocation, useNavigate} from 'react-router-dom';
import SearchSelect from '../../../../components/virtualized-select/searchSelect';
import {useDispatch, useSelector} from 'react-redux';
import {
  addSubCategoryEvents,
  deleteSubCategoryEvents,
  getRiskAssessmentTasks,
  getTaskDetail,
  importEvent,
  markNoExpToUnWantedEvents,
  setScrollPosition,
  deleteNotes,
} from '../../../../../../../redux/risk-assessment-core/riskAssessmentCoreSlice';
import {allRoutes} from '../../../../../../../utils/routeConstants';
import Alert from '../../../../../../../components/alert/alert';
import SubCategoryEvents from './event-sub-category-row';
import ViewInfo from '../../../../components/view-info/view-info';
import {
  eventRowInfoIconEnum,
  EventStatusEnum,
  getUserRoleName,
  EventStatusIds,
} from '../../../../../../../utils/constants';
import ImportEvent from '../../../../components/import-event/importEvent';
import AnonymousScoring from '../../../../components/anonymous-scoring/anonymousScoring';
import {getLoginStateSelector} from '../../../../../../../redux/selectors/loginSelector';
import {toast} from 'react-toastify';
import Confirmation from '../../../../../../../components/confirmation/confirmation';
import useConfirmationModal from '../../../../../../../hooks/useConfirmationModal';
import useAutoResizingTextarea from '../../../../../../../hooks/useAutoResizingTextArea';
import useEditSave from './hooks/useEditSave';
import {getTaskDetailsScroller} from '../../../../../../../utils/scrollUtils';

const SubCategoryDropdown = ({handleListChange, onSubCategoryCancel, id}) => {
  const [selectedList, setSelectedList] = React.useState([]);


  return (
    <div className="sub-category-wrapper">
      <SearchSelect handleListChange={data => setSelectedList(data)} id={id} />
      <a className="add-button" onClick={() => handleListChange(selectedList)}>
        Add
      </a>
      <a className="add-button" onClick={() => onSubCategoryCancel()}>
        Cancel
      </a>
    </div>
  );
};

export default function EventRow({data}) {
  const loginState = useSelector(getLoginStateSelector());
  const {loggedInUser} = loginState;
  const [showNoteInput, setShowNoteInput] = useState(data?.note?.length > 0);
  const [isExposedInput, setIsExposedInput] = useState('');
  const [isExposedInputYes, setIsExposedInputYes] = useState(false);
  const [isExposedInputNo, setIsExposedInputNo] = useState(false);
  const [addSubCategory, setAddSubCategory] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [noClickHelpText, setNoClickHelpText] = useState('');
  const [parentNoteValue, setParentNoteValue] = useState(data.note || '');
  const [subCategoryList, setSubCategoryList] = useState(
    data?.sub_cat_data || [],
  );
  const [editDetails, setEditDetails] = useState(data?.note);
  const [showImportModal, setShowImportModal] = useState(false);
  const [showScoringModal, setShowScoringModal] = useState(false);
  const dispatch = useDispatch();
  const location = useLocation();
  const nav = useNavigate();
  const readOnly = getUserRoleName(loggedInUser?.role) === 'general';

  const currentNavState = location.state;
  const selectedRiskAssessment = currentNavState?.selectedRiskAssessment;

  const textareaRef = useRef(null);
  const {handleInputChange} = useAutoResizingTextarea(
    textareaRef,
    parentNoteValue,
    setParentNoteValue,
    isExposedInput,
  );
  const {isEditMode, toggleMode, saveData} = useEditSave(
    data?.note?.length ? true : false,
  );

  const {isVisible, config, showModal, hideModal, confirmAction} =
    useConfirmationModal({
      onConfirm: data => {
        if (data)
          clearNoteToEventSubCat(data, () => {
            setShowNoteInput(false);
            setParentNoteValue('');
            setEditDetails('');
          });
      },
      onCancel: () => {},
    });

  useEffect(() => {
    setSubCategoryList(data?.sub_cat_data || []);
  }, [data?.sub_cat_data]);

  const handleEventSelection = (eventName, id) => {
    // Capture from whichever element actually scrolls (wrapper or document).
    const scrollContainer = getTaskDetailsScroller();
    const scrollPosition = scrollContainer?.scrollTop || 0;

    // Save the clicked PUE's id (so we can return to that exact row, robust to
    // height changes) plus the pixel offset as a fallback, scoped to the task.
    const taskId = currentNavState?.selectedTask?.id ?? data?.task ?? null;
    dispatch(
      setScrollPosition({position: scrollPosition, taskId, eventMappingId: id}),
    );

    const raId =
      selectedRiskAssessment &&
      typeof selectedRiskAssessment === 'object' &&
      selectedRiskAssessment.id != null
        ? selectedRiskAssessment.id
        : null;
    const qs = new URLSearchParams();
    qs.set('eventMappingId', String(id));
    if (raId != null) {
      qs.set('riskAssessmentId', String(raId));
    }

    nav(
      {
        pathname: allRoutes.dashboardRoutes.assessmentRoutes.eventDetails,
        search: `?${qs.toString()}`,
      },
      {
        state: {
          ...location.state,
          selectedEventName: eventName,
          eventId: id,
          scrollPosition,
        },
      },
    );
  };

  useEffect(() => {
    const expSelection =
      data.exp_unwntd_events === 1
        ? 'yes'
        : data.exp_unwntd_events === 0
        ? 'no'
        : '';
    setIsExposedInput(expSelection);
  }, [data]);

  useEffect(() => {
    if (isExposedInput === 'yes') {
      setIsExposedInputYes(true);
      setIsExposedInputNo(false);
    } else {
      setIsExposedInputNo(true);
      setIsExposedInputYes(false);
    }
  }, [isExposedInput]);

  const handleSave = () => {
    // if (subCategoryList.length) {
    //   setShowAlert(true);
    //   const text = [
    //     'Please delete Event Subcategories for event ',
    //     "'",
    //     <strong>{data.event_detail.name}</strong>,
    //     "'",
    //   ];

    //   setNoClickHelpText(text);
    //   return;
    // }

    toast.success('Event Saved', {
      autoClose: 2000,
      className: 'toast-success',
    });
    setAddSubCategory(false);
    setSubCategoryList([]);
    setNoExposureUnwntdEvents();
    setEditDetails(parentNoteValue);
    if (parentNoteValue?.length === 0) setShowNoteInput(false);
  };


  const handleDeleteNote = () => {
    const subCat = data;
    const lengthOfNote = editDetails?.length;
    if (!lengthOfNote || lengthOfNote === 0) {
      setShowNoteInput(false);
      setParentNoteValue('');
    } else
      showModal({
        label: 'Are you sure you want to clear the note?',
        confirmationType: 'warning',
        subCat,
      });
    setEditDetails(parentNoteValue);
    if (parentNoteValue?.length === 0) setShowNoteInput(false);
  };

  const handleNoClicked = async () => {
    await saveData(() => handleSave());
  };

  const handleCategoryNoClicked = () => {
    setIsExposedInput('no');
    setNoExposureUnwntdEvents(true);
  };

  const handleYesClicked = () => {
    setIsExposedInput('yes');
    const eventMappingId = data.id;
    const payload = {
      task: data.task,
      event: data.event,
      exp_unwntd_events: 1,
    };
    dispatch(
      markNoExpToUnWantedEvents({
        id: eventMappingId,
        payload,
        callback: result => {
          if (result?.status === 200) {
            if (result?.data?.exp_unwntd_events === 0) setIsExposedInput('no');
            else setIsExposedInput('yes');
          }
          // Refetch only after the mark has committed, otherwise the refetched
          // (stale) data reverts the optimistic selection via the data effect.
          fetchTaskDetail(currentNavState?.selectedTask.id);
        },
      }),
    );
  };

  // marking No to an event
  const setNoExposureUnwntdEvents = isNoClicked => {
    const eventMappingId = data.id;
    const payload = {
      task: data.task,
      event: data.event,
      exp_unwntd_events: isNoClicked ? 0 : isExposedInput === 'no' ? 0 : 1,
      note: parentNoteValue,
    };
    dispatch(
      markNoExpToUnWantedEvents({
        id: eventMappingId,
        payload,
        callback: result => {
          if (result?.status === 200) {
            if (result?.data?.exp_unwntd_events === 0) setIsExposedInput('no');
            else setIsExposedInput('yes');
          }

          fetchTaskDetail(currentNavState?.selectedTask.id);
        },
      }),
    );
  };

  const addNoteToEventSubCat = (subCatId, note) => {
    const eventMappingId = subCatId;
    const payload = {
      note: note,
    };
    // using same 'mark no' patch API. Rename required during code refactor
    dispatch(
      markNoExpToUnWantedEvents({
        id: eventMappingId,
        payload,
        callback: result => {
          if (result?.status === 200) {
            toast.success('Sub Category Saved', {
              autoClose: 2000,
              className: 'toast-success',
            });
          }
        },
      }),
    );
  };

  const clearNoteToEventSubCat = (subCatId, onSuccess) => {
    dispatch(
      deleteNotes({
        id: subCatId,
        callback: result => {
          if (result.status === 200) {
            setSubCategoryList(prevData =>
              prevData.map(item =>
                item.id === subCatId ? {...item, note: null} : item,
              ),
            );
            if (onSuccess) {
              onSuccess();
            }
          }
        },
      }),
    );
  };

  const handleSubCategoryListChange = subCategoryListData => {
    const payload = subCategoryListData.map(el => {
      return {
        task: data.task,
        event: data.event,
        exp_unwntd_events: 1,
        event_sub_category: el.id,
      };
    });
    dispatch(
      addSubCategoryEvents({
        payload,
        callback: result => {
          if (result.status === 200) {
            setSubCategoryList([...subCategoryList, ...result.data]);
            toast.success('Sub Category Added', {
              autoClose: 2000,
              className: 'toast-success',
            });
          }
          setAddSubCategory(false);
        },
      }),
    );
  };

  const handldeSubCatDelete = (eventMappingId, id) => {
    const payload = {
      task: data.task,
      event: data.event,
      event_sub_category: id,
    };
    dispatch(
      deleteSubCategoryEvents({
        id: eventMappingId,
        payload,
        callback: result => {
          if (result.data === '') {
            setSubCategoryList(
              subCategoryList.filter(
                el => el?.id !== eventMappingId,
              ),
            );
            toast.success('Subcategory deleted successfully.', {
              autoClose: 2000,
              className: 'toast-success',
            });
          } else {
            toast.error('Unable to delete subcategory. Please try again.', {
              autoClose: 2000,
              className: 'toast-error',
            });
           
          } 
          setAddSubCategory(false);
        },
      }),
    );
  };
  const handleImportEventAction = payload => {
    dispatch(
      importEvent({
        payload,
        callback: resp => {
          setShowImportModal(false);
          const id = location?.state?.selectedTask.id;
          dispatch(
            getTaskDetail({
              id,
              callback: resp => {},
            }),
          );
        },
      }),
    );
  };

  const handleSubCategoryReset = () => {
    setAddSubCategory(false);
  };

  const eventStatusItem = EventStatusEnum.find(
    item =>
      data?.event_status != null &&
      data?.event_status !== '' &&
      Number(item.value) === Number(data.event_status),
  );

  function fetchTaskDetail(id) {
    dispatch(
      getTaskDetail({
        id,
        callback: resp => {},
      }),
    );
  }
  
  const handleShowModal = () => {
    setShowScoringModal(true);
  }

  return (
    <div className="event-row-wrapper" data-pue-id={data?.id}>
      <div>
        <div className="row-1">
          <div className="heading">
            <span className="number">{data?.event_detail?.event_sequence}</span>

            <div className="name-note-container">
              <span className="name">{data?.event_detail?.name}</span>
              {data?.event_detail?.description &&<span className="description">{data?.event_detail?.description}</span>}
              {/* {data.note && <div className="note">{data.note}</div>} */}
            </div>

            {/* <span className="name">{data?.event_detail?.name}</span> */}
          </div>
          <div className="more-details">
            <div style={{marginRight: '10px', display: 'flex', gap: '12px'}}>
              {data?.score && (
                <span style={{color: 'blue', fontWeight: 'bold'}}>
                 MPLr : {data?.score}
                </span>
              )}
              {!subCategoryList?.length &&  data?.action_required_by && (
                <span style={{color: 'red', fontWeight: 'bold'}}>
                  Action required
                </span>
              )}

              {eventStatusItem && (
                <span style={{color: eventStatusItem?.color}}>
                  {eventStatusItem?.label}
                </span>
              )}
            </div>
            {/* <div style={{marginRight: '10px'}}>
              {eventStatusItem && data?.exp_unwntd_events !== null && (
                <span style={{color: eventStatusItem.color}}>
                  {(data?.event_status === EventStatusIds.NotStarted ||
                    data?.event_status === EventStatusIds.InProgress) &&
                  data?.action_required_by ? (
                    <span style={{color: 'red', fontWeight: 'bold'}}>
                      Action required
                    </span>
                  ) : (
                    eventStatusItem.label
                  )}
                </span>
              )}
            </div> */}
          {location.state?.type !==2 &&  <div className="info-events">
              <ViewInfo label={eventRowInfoIconEnum[data?.event_detail?.id]} />
            </div>}
            {subCategoryList.length == 0 && !readOnly && (
              <div
                className="copy-events"
                onClick={() => setShowImportModal(true)}>
                <img style={{marginRight: '5px'}} src={assets.copyIcon} />
                Import
              </div>
            )}

            <div className="unwanted-events">
              <Button
                clickHandler={() => handleShowModal()}
                variant='submit-button'>
                Anonymous Scoring
              </Button>
              <span className="text">Exposure to unwanted event</span>
              <span className="action-btns">
                <Button
                  clickHandler={() => handleYesClicked()}
                  variant={
                    isExposedInput === 'yes'
                      ? 'submit-button'
                      : 'secondary-button'
                  }
                  disabled={readOnly}>
                  Yes
                </Button>
                <Button
                  clickHandler={() => handleCategoryNoClicked()}
                  variant={
                    isExposedInput === 'no'
                      ? 'submit-button'
                      : 'secondary-button'
                  }
                  disabled={readOnly}>
                  No
                </Button>
              </span>
            </div>
            {isExposedInputYes && !subCategoryList.length && (
              <span
                className="forward-arrow"
                style={{cursor: 'pointer'}}
                onClick={() =>
                  handleEventSelection(data?.event_detail?.name, data?.id)
                }>
                <img src={assets.chevronRight} />
              </span>
            )}
          </div>
        </div>
        {/* If No clicked */}
        {isExposedInput === 'no' && !readOnly && (
          <div className="row-2">
            {!showNoteInput ? (
              <span onClick={() => setShowNoteInput(true)}>
                <img src={assets.addFilled} />
                <span className="add-note-text">Add note</span>
              </span>
            ) : (
              <div className="note-row">
                <label htmlFor="note-input">Note (optional)</label>
   
                <textarea
                  id="note-input-parent"
                  ref={textareaRef}
                  value={parentNoteValue}
                  onChange={handleInputChange}
                  disabled={isEditMode}
                  rows="1"
                  style={{
                    overflow: 'hidden',
                    resize: 'none',
                    width: '100%',
                    minHeight:"50px"

                  }}
                />


               

                <span className="items-container">
                  {isEditMode ? (
                    <span
                      className="edit"
                      onClick={e => {
                        e.stopPropagation();
                        toggleMode();
                      }}>
                      <img
                        src={assets.editIcon2}
                        style={{
                          cursor: 'pointer',
                          scaale: '1.2',
                          marginLeft: '5px',
                        }}
                        alt="edit"
                      />
                    </span>
                  ) : (
                    <>
                      <img
                        style={{
                          scale: '1.2',
                          cursor:
                            editDetails?.length > 0 ||
                            parentNoteValue?.length > 0
                              ? 'pointer'
                              : 'default',
                          opacity:
                            editDetails?.length > 0 ||
                            parentNoteValue?.length > 0
                              ? 1
                              : 0.5,
                        }}
                        onClick={
                          editDetails?.length > 0 || parentNoteValue?.length > 0
                            ? handleNoClicked
                            : undefined
                        }
                        src={assets.checkIcon}
                        alt="Checkmark"
                      />
                      <img
                        style={{scale: '1.2', cursor: 'pointer'}}
                        onClick={() => handleDeleteNote()}
                        src={assets.closeIcon}
                        alt="Close"
                      />
                    </>
                  )}
                </span>
              </div>
            )}
          </div>
        )}
        {/* If yes clicked */}
        {((isExposedInput === 'yes' && !readOnly) ||
          !!subCategoryList.length) && (
          <div className="row-2">
            {isExposedInput === 'yes' && (
              <>
                {!showNoteInput ? (
                  <span onClick={() => setShowNoteInput(true)}>
                    <img src={assets.addFilled} />
                    <span className="add-note-text">Add note</span>
                  </span>
                ) : (
                  <div className="note-row">
                    <label htmlFor="note-input">Note (optional)</label>

         
                    <textarea
                      id="note-input-parent"
                      ref={textareaRef}
                      value={parentNoteValue}
                      onChange={handleInputChange}
                      rows="1"
                      disabled={isEditMode}
                      style={{
                        overflow: 'hidden',
                        resize: 'none',
                        width: '100%',
                        minHeight:"50px"
                      }}
                    />

                  
                    

                    <span className="items-container">
                      {isEditMode ? (
                        <span
                          className="edit"
                          onClick={e => {
                            e.stopPropagation();
                            toggleMode();
                          }}>
                          <img
                            src={assets.editIcon2}
                            style={{
                              cursor: 'pointer',
                              scaale: '1.2',
                              marginLeft: '5px',
                            }}
                            alt="edit"
                          />
                        </span>
                      ) : (
                        <>
                          <img
                            style={{
                              scale: '1.2',
                              cursor:
                                editDetails?.length > 0 ||
                                parentNoteValue?.length > 0
                                  ? 'pointer'
                                  : 'default',
                              opacity:
                                editDetails?.length > 0 ||
                                parentNoteValue?.length > 0
                                  ? 1
                                  : 0.5,
                            }}
                            onClick={
                              editDetails?.length > 0 ||
                              parentNoteValue?.length > 0
                                ? handleNoClicked
                                : undefined
                            }
                            src={assets.checkIcon}
                            alt="Checkmark"
                          />
                          <img
                            style={{scale: '1.2', cursor: 'pointer'}}
                            onClick={() => handleDeleteNote()}
                            src={assets.closeIcon}
                            alt="Close"
                          />
                        </>
                      )}
                    </span>
                  </div>
                )}
              </>
            )}


            {isExposedInput === 'yes' && !readOnly && (
              <span
                className="event-sub-category-text"
                onClick={() => setAddSubCategory(true)}>
                Add event subcategory
              </span>
            )}
          </div>
        )}


        {addSubCategory && (

          <SubCategoryDropdown
            handleListChange={handleSubCategoryListChange}
            onSubCategoryCancel={handleSubCategoryReset}
            id={data?.event_detail?.id}
          />
        )}
      </div>
      {!!subCategoryList.length &&
        isExposedInput === 'yes' &&
        subCategoryList.map((subCat, idx) => (
          <SubCategoryEvents
            key={idx}
            subCat={subCat}
            idx={idx}
            handleEventSelection={() =>
              handleEventSelection(
                `${data?.event_detail?.name} - ${subCat?.event_sub_category_detail?.name}`,
                subCat?.id,
              )
            }
            handldeSubCatDelete={handldeSubCatDelete}
            addNoteToEventSubCat={addNoteToEventSubCat}
            clearNoteToEventSubCat={clearNoteToEventSubCat}
            readOnly={readOnly}
          />
        ))}
      {/* {showAlert && (
        <Alert
          label={'Alert'}
          show={showAlert}
          setShow={setShowAlert}
          helpText={noClickHelpText}
        />
      )} */}
      {showImportModal && (
        <ImportEvent
          label={'Import'}
          show={showImportModal}
          setShow={setShowImportModal}
          data={data}
          handleImportEventAction={handleImportEventAction}
          assessmentType={location.state?.type}
        />
      )}

      <Confirmation
        label={config.label}
        show={isVisible}
        setShow={hideModal}
        confirmationType={'typeDelete'}
        secondaryButtonClickHandler={hideModal}
        primaryButtonClickHandler={() => confirmAction(config.dynamicData)}
      />
      {showScoringModal && (
        <AnonymousScoring
          label="Anonymous Scoring"
          show={showScoringModal}
          setShow={setShowScoringModal}
          data={data}
          parentNoteValue={parentNoteValue}
        />
      )}
    </div>
  );
}
